import { defineMessage } from 'services/localization';

export const messages = {
    transactionNumberFieldText: defineMessage('transaction_number'),
    dateFieldText: defineMessage('date'),
    memoFieldText: defineMessage('memo'),
    departmentFieldText: defineMessage('department'),
    classFieldText: defineMessage('class'),
    locationFieldText: defineMessage('location'),
};
